import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ValueAccessorBase } from '../form-controls-core/value-acessor-base';

@Component({
    selector: 'app-form-date-picker',
    templateUrl: 'form-date-picker.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FormDatePickerComponent),
        multi: true
    }, {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
    }]
})
export class FormDatePickerComponent extends ValueAccessorBase<number> {

    private static dateRgx = new RegExp(/^\d{1,2}.\d{1,2}.\d{4}$/);

    private innerMomentValue: moment.Moment;

    get momentValue(): moment.Moment {
        if (!this.innerMomentValue && this.value) {
            this.innerMomentValue = moment(this.value);
        }
        return this.innerMomentValue;
    }

    set momentValue(value: moment.Moment) {
        this.innerMomentValue = value;
        this.value = value.toDate().getTime();
    }

    private parseDate(src: string): number {
        if (FormDatePickerComponent.dateRgx.exec(src)) {
            return moment(src, 'DD.MM.YYYY').toDate().getTime();
        } else {
            return 0;
        }
    }

    public dateChange(event: MatDatepickerInputEvent<moment.Moment>) {
        if (event.value) {
            const input = event.value.creationData().input;
            if (typeof input === 'object') {
                this.momentValue = event.value;
            } else if (typeof input === 'string') {
                const parsedValue = this.parseDate(input);
                if (this.parseDate) {
                    this.value = parsedValue;
                }
            }
        } else {
            this.value = 0;
        }
    }
}
